import { Layout } from "../read/Layout";

export class LayoutDto {
  id: string;
  image: string;
  imageMimetype: string;
  layout?: Layout;
  constructor(
    id: string,
    image: string,
    imageMimetype: string,
    layout?: Layout
  ) {
    (this.id = id),
      (this.image = image),
      (this.imageMimetype = imageMimetype),
      (this.layout = layout);
  }
}
